import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Taxiserviceinhadapsar() {



const cardData = {
  keyword: " Taxi Service in Hadapsar  ",

"headingDescription": "SRS Cab Service offers Taxi Service in Hadapsar, providing reliable, comfortable, and affordable travel solutions for daily commuting, business trips, and local sightseeing. Our well-maintained vehicles, professional drivers, and prompt pickups ensure a smooth and hassle-free journey across Hadapsar and Pune city. Ideal for airport transfers, office travel, and outstation trips, SRS Cab Service delivers flexible booking options, transparent pricing, and 24/7 customer support for a convenient and stress-free travel experience.",
"topPlaces": [
  {
    "title": "Amanora Mall",
    "description": "Amanora Mall is a popular shopping and entertainment destination in Hadapsar. Travelers using Taxi Service in Hadapsar from SRS Cab Service often visit for shopping, dining, and movies."
  },
  {
    "title": "Seasons Mall",
    "description": "Seasons Mall is another major mall in Hadapsar known for retail stores and food outlets. Visitors using SRS Cab Service often explore this place for leisure and entertainment."
  },
  {
    "title": "Magarpatta City",
    "description": "Magarpatta City is a well-planned township and IT hub in Hadapsar. Travelers using SRS Cab Service often commute here for business meetings and corporate travel."
  },
  {
    "title": "Empress Botanical Garden",
    "description": "Empress Botanical Garden is a lush green garden near Hadapsar. Visitors using SRS Cab Service often relax here and enjoy nature walks."
  },
  {
    "title": "Amanora Lake",
    "description": "Amanora Lake is a scenic spot ideal for evening walks and relaxation. Travelers using SRS Cab Service often visit this place for peaceful surroundings."
  },
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is a historic fort located a short drive from Hadapsar. Visitors using SRS Cab Service often explore this landmark to learn about Pune’s heritage."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a major historical site near Hadapsar. Travelers using SRS Cab Service often visit for its gardens and museum exhibits."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Dagdusheth Halwai Ganpati Temple is a famous religious site in Pune. Visitors using SRS Cab Service often stop here to seek blessings."
  },
  {
    "title": "Katraj Snake Park",
    "description": "Katraj Snake Park is a popular attraction for wildlife enthusiasts. Travelers using SRS Cab Service often visit with family for an educational experience."
  },
  {
    "title": "Saras Baug",
    "description": "Saras Baug is a well-known garden and temple spot in Pune. Visitors using SRS Cab Service often relax here and enjoy the peaceful environment."
  }
],



services: [
{
name: "Hadapsar Taxi Service",
description: "Hadapsar taxi service offers reliable transportation for local and outstation travel. Customers can book taxis for daily and occasional trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services in Hadapsar."
},
{
name: "Taxi Booking Hadapsar",
description: "Taxi booking Hadapsar provides quick and easy reservation options. Customers can book taxis online or via phone. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your taxi easily in Hadapsar."
},
{
name: "Taxi in Hadapsar",
description: "Taxi in Hadapsar offers convenient travel for local and outstation trips. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services in Hadapsar."
},
{
name: "Cab Service Hadapsar",
description: "Cab service Hadapsar provides reliable transportation for city and intercity travel. Customers can book cabs for business and personal use. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Hadapsar Cab Booking",
description: "Hadapsar cab booking offers quick reservation options for travelers. Customers can book cabs online or offline. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily in Hadapsar."
},
{
name: "Reliable Taxi Hadapsar",
description: "Reliable taxi Hadapsar provides dependable transportation for all travel needs. Customers can book trusted taxi services for safe journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with reliable taxi services."
},
{
name: "Affordable Taxi Hadapsar",
description: "Affordable taxi Hadapsar offers budget-friendly travel for daily and long-distance trips. Customers can book taxis at competitive prices. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with affordable taxi services."
},
{
name: "24/7 Taxi Service Hadapsar",
description: "24/7 taxi service Hadapsar provides round-the-clock transportation for customers. Travelers can book taxis anytime for urgent needs. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with 24/7 taxi services."
},
{
name: "Airport Taxi Hadapsar",
description: "Airport taxi Hadapsar offers reliable transfer services to and from airports. Customers can book taxis for timely pickups and drops. Professional drivers ensure punctual journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport taxi services."
},
{
name: "Luxury Taxi Hadapsar",
description: "Luxury taxi Hadapsar provides premium travel experience for customers. Users can enjoy high-end vehicles with extra comfort. Professional drivers ensure safe journeys. Spacious seating enhances experience. Flexible booking options are available. Travel comfortably with luxury taxi services."
},
{
name: "Taxi Near Hadapsar",
description: "Taxi near Hadapsar offers nearby booking options for quick travel. Customers can find taxis easily for instant rides. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book taxis easily near Hadapsar."
},
{
name: "Cab Service in Hadapsar",
description: "Cab service in Hadapsar provides convenient transportation for city and outstation travel. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Cab Service in Magarpatta City",
description: "Cab service in Magarpatta City offers reliable travel for residents and offices. Customers can book cabs for daily and corporate trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Taxi Service in Magarpatta City",
description: "Taxi service in Magarpatta City provides dependable transportation for local travel. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Outstation Cabs Hadapsar",
description: "Outstation cabs Hadapsar offer reliable travel for long-distance trips. Customers can book cabs for one-way or round journeys. Professional drivers ensure safe highway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with outstation cab services."
},
{
name: "Cheap Cab Service in Hadapsar",
description: "Cheap cab service in Hadapsar provides budget-friendly transportation for daily travel. Customers can book cabs at affordable rates. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with cheap cab services."
},
{
name: "Hadapsar to Mumbai Cabs",
description: "Hadapsar to Mumbai cabs offer reliable intercity travel for business and leisure trips. Customers can book cabs for comfortable journeys. Professional drivers ensure safe highway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Hadapsar to Shirdi Cab",
description: "Hadapsar to Shirdi cab provides convenient travel for temple visits. Customers can book cabs for pilgrimage journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Hadapsar to Solapur Cab Service",
description: "Hadapsar to Solapur cab service offers reliable transportation for long-distance travel. Customers can book cabs for business and family trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Best Cab Service in Hadapsar",
description: "Best cab service in Hadapsar provides top-rated transportation for customers. Travelers can enjoy high-quality service with comfort. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with best cab services."
},
{
name: "Affordable Cab Service Hadapsar",
description: "Affordable cab service Hadapsar offers cost-effective travel for daily and long trips. Customers can book cabs at competitive prices. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with affordable cab services."
},
{
name: "Hadapsar Cab Hire",
description: "Hadapsar cab hire provides flexible vehicle options for local and outstation travel. Customers can hire cabs for personal and business use. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Hire cabs easily in Hadapsar."
},
{
name: "Hadapsar Taxi Hire",
description: "Hadapsar taxi hire offers convenient transportation for daily travel needs. Customers can hire taxis for flexible trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi hire services."
},
{
name: "Hadapsar Cab for Outstation",
description: "Hadapsar cab for outstation provides reliable travel for long-distance journeys. Customers can book cabs for tours and business trips. Professional drivers ensure safe highway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with outstation cab services."
},
{
name: "Hadapsar Cab for Airport",
description: "Hadapsar cab for airport offers convenient transfer services to airports. Customers can book cabs for timely pickups and drops. Professional drivers ensure punctual journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Hadapsar Cab for One Way",
description: "Hadapsar cab for one way provides economical travel without return charges. Customers can book direct rides easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one way cab services."
},
{
name: "Cab Service Hadapsar Pune",
description: "Cab service Hadapsar Pune offers reliable transportation for city and outstation travel. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Taxi Service Hadapsar Pune",
description: "Taxi service Hadapsar Pune provides convenient travel for daily and long-distance trips. Customers can book taxis for flexible travel plans. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
}
],

tableData: [
["Hadapsar Taxi Service","Taxi Booking Hadapsar"],
["Taxi in Hadapsar","Cab Service Hadapsar"],
["Hadapsar Cab Booking","Reliable Taxi Hadapsar"],
["Affordable Taxi Hadapsar","24/7 Taxi Service Hadapsar"],
["Airport Taxi Hadapsar","Luxury Taxi Hadapsar"],
["Taxi Near Hadapsar","Cab Service in Hadapsar"],
["Cab Service in Magarpatta City","Taxi Service in Magarpatta City"],
["Outstation Cabs Hadapsar","Cheap Cab Service in Hadapsar"],
["Hadapsar to Mumbai Cabs","Hadapsar to Shirdi Cab"],
["Hadapsar to Solapur Cab Service","Best Cab Service in Hadapsar"],
["Affordable Cab Service Hadapsar","Hadapsar Cab Hire"],
["Hadapsar Taxi Hire","Hadapsar Cab for Outstation"],
["Hadapsar Cab for Airport","Hadapsar Cab for One Way"],
["Cab Service Hadapsar Pune","Taxi Service Hadapsar Pune"]
],



whychoose: [
  {
    WhyChooseheading: "Local Expertise in Hadapsar Area",
    WhyChoosedescription: "SRS Cab Service provides reliable taxi service in Hadapsar with drivers familiar with local routes, traffic patterns, and nearby IT hubs like Magarpatta and SP Infocity."
  },
  {
    WhyChooseheading: "Affordable Taxi Service in Hadapsar",
    WhyChoosedescription: "We offer budget-friendly taxi services in Hadapsar with transparent pricing. Customers receive clear fare details without hidden charges."
  },
  {
    WhyChooseheading: "24/7 Taxi Availability",
    WhyChoosedescription: "SRS Cab Service operates 24/7 in Hadapsar, making it convenient for daily travel, office commutes, airport transfers, and emergency bookings."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles",
    WhyChoosedescription: "Our fleet includes clean, well-maintained, and air-conditioned vehicles to ensure a comfortable and smooth ride within Hadapsar and across Pune."
  },
  {
    WhyChooseheading: "Multiple Cab Options",
    WhyChoosedescription: "Choose from hatchbacks, sedans, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for local and outstation travel."
  },
  {
    WhyChooseheading: "Quick Pickup & Doorstep Service",
    WhyChoosedescription: "We provide fast pickup from homes, offices, apartments, and commercial areas across Hadapsar including Magarpatta, Amanora, and nearby locations."
  },
  {
    WhyChooseheading: "Safe & Professional Drivers",
    WhyChoosedescription: "Our experienced drivers ensure safe driving, polite behavior, and smooth travel for every ride in and around Hadapsar."
  },
  {
    WhyChooseheading: "Trusted Taxi Service in Hadapsar Pune",
    WhyChoosedescription: "SRS Cab Service is trusted by local residents and office commuters for reliable, punctual, and affordable taxi service in Hadapsar."
  }
]
}

const faqData = [
  { question: "Do you provide taxi service in Hadapsar?", answer: "Yes, SRS Cab Service offers reliable taxi services in Hadapsar for local and outstation travel." },
  { question: "Is taxi service available in Hadapsar 24 hours?", answer: "Yes, our taxi service operates 24/7 for all travel needs." },
  { question: "Do you provide airport cab service from Hadapsar?", answer: "Yes, we provide Pune Airport pickup and drop services from Hadapsar." },
  { question: "Which areas do you cover in Hadapsar?", answer: "We cover Magarpatta, Amanora, Gadital, SP Infocity, and nearby areas." },
  { question: "Which vehicles are available?", answer: "We offer hatchbacks, sedans, SUVs, Innova Crysta, and Tempo Travellers." },
  { question: "Can I book taxi online in Hadapsar?", answer: "Yes, you can easily book taxi service online or via phone." },
  { question: "Do you provide one-way cab service?", answer: "Yes, we provide one-way and round-trip cab services from Hadapsar." },
  { question: "Are drivers professional?", answer: "Yes, all drivers are trained, experienced, and professional." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Jadhav",
    feedback:
      "Booked taxi from Hadapsar to airport. Very quick service and smooth ride.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Pooja Sharma",
    feedback:
      "Best taxi service in Hadapsar. Clean car, polite driver, and on-time pickup.",
    rating: 5
  }
];




























const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];













const jsonData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SRS Cab - Hadapsar Taxi Service",
  "description": "Reliable taxi service in Hadapsar with SRS Cab. Book affordable cabs for local travel, airport transfers, and outstation trips. 24/7 service with luxury, sedan, and tempo traveller options.",
  "image": "https://www.srscabservice.com/logo.png",
  "telephone": "+91 9011955415",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Hadapsar",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411028",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "18.5023",
    "longitude": "73.9180"
  },
  "url": "https://www.srscabservice.com/hadapsar-taxi-service",
  "priceRange": "₹₹",
  "openingHours": "Mo-Su 00:00-23:59",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "1570"
  },
  "areaServed": {
    "@type": "City",
    "name": "Hadapsar, Pune"
  }
};





  return (
    <div>
      <Helmet>
  <title>Taxi Service in Hadapsar | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book reliable and affordable taxi service in Hadapsar, Pune with SRS Cab. Local rides, airport transfers, and outstation cabs available 24/7. Luxury, sedan, and tempo traveller options." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>




 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/48.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Taxiserviceinhadapsar;